<ng-container *ngIf="head">
    <tt-toast *ngIf="head.validationmessage" [ttTitle]="head.validationmessage" ttTranslateTitle="false" ttType="danger"></tt-toast>
    <tt-select
        ttLabelView="top"
        ttLabel="acvouchertype"
        [(ttModel)]="head.acvouchertype_id"
        (ttModelChange)="onVoucherTypeChanged()"
        [ttData]="voucherTypes"
        ttDataId="acvouchertype_id"
        ttDataName="acvouchertype_name"
        [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
    ></tt-select>
    <div *ngIf="head.show_supplier_name === '1'" class="w-accountingprocessing__input-group">
        <tt-input ttLabelView="top" ttLabel="acc_supp_no" [ttModel]="head.acc_supp_no" ttReadonly></tt-input>
        <tt-search
            ttLabelView="top"
            ttLabel="supplier_name"
            [(ttModel)]="head.supplier_name"
            [ttSearch]="searchSupplierAccountInfo"
            (ttOnSelected)="onSupplierSelected($event)"
            (ttOnClear)="onSupplierSelected()"
            [ttButtons]="head.cust_no > '0' ? supplierButtons : supplierEmptyButtons"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
            style="flex: 4"
        ></tt-search>
    </div>
    <div *ngIf="head.show_cust_name === '1'" class="w-accountingprocessing__input-group">
        <tt-input ttLabelView="top" ttLabel="acc_cust_no" [ttModel]="head.acc_cust_no" ttReadonly></tt-input>
        <tt-search
            ttLabelView="top"
            ttLabel="cust_name"
            [(ttModel)]="head.cust_name"
            [ttSearch]="searchCustomerAccountInfo"
            (ttOnSelected)="onCustomerSelected($event)"
            (ttOnClear)="onCustomerSelected()"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
            style="flex: 4"
        ></tt-search>
    </div>
    <div class="col-xs-12 sp-0 w-accountingprocessing__input-group">
        <tt-input
            *ngIf="head.show_rem_invoice_no === '1'"
            ttLabelView="top"
            ttLabel="rem_invoice_no"
            [(ttModel)]="head.rem_invoice_no"
            (ttModelChange)="saveCustact('rem_invoice_no')"
            ttMaxLength="50"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-input>
        <tt-search
            *ngIf="head.show_voucher_no_match === '1'"
            class="w-accountingprocessing__input"
            ttLabelView="top"
            ttLabel="voucher_no_match"
            [(ttModel)]="head.voucher_no_match"
            [ttSearch]="searchVoucherNoMatch"
            ttDataId="voucher_no"
            ttDataName="voucher_name"
            (ttOnSelected)="onVoucherNoMatchSelected($event)"
            (ttOnClear)="onVoucherNoMatchSelected()"
            ttMinLength="0"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-search>
    </div>
    <div class="w-accountingprocessing__input-group">
        <tt-date
            *ngIf="head.show_voucherdate === '1'"
            ttLabelView="top"
            ttLabel="voucherdate"
            [(ttModel)]="head.voucherdate"
            (ttModelChange)="custactColChanged('voucherdate')"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
            ttAllowEmpty="false"
        ></tt-date>
        <tt-date
            *ngIf="head.show_transdate === '1'"
            ttLabelView="top"
            ttLabel="transdate"
            [(ttModel)]="head.transdate"
            (ttModelChange)="custactColChanged('transdate')"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
            ttAllowEmpty="false"
        ></tt-date>
        <tt-date
            *ngIf="head.show_duedate === '1'"
            ttLabelView="top"
            ttLabel="duedate"
            [(ttModel)]="head.duedate"
            (ttModelChange)="saveCustact('duedate')"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
            ttAllowEmpty="false"
        ></tt-date>
    </div>
    <div class="w-accountingprocessing__input-group">
        <tt-input-number
            *ngIf="head.show_amount_invval_abs === '1'"
            ttLabelView="top"
            ttLabel="amount_invval_abs"
            [(ttModel)]="head.amount_invval_abs"
            (ttModelChange)="onAmountInvvalAbsChanged()"
            ttTextAlign="right"
            ttFormatNumber
            ttDecimals="2"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-input-number>
        <tt-select
            *ngIf="head.show_valuta_id === '1'"
            ttLabelView="top"
            ttLabel="valuta"
            [(ttModel)]="head.valuta_id"
            (ttModelChange)="onValutaChanged()"
            [ttData]="valutas"
            ttDataId="valuta_id"
            ttDataName="valuta_name"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-select>
        <tt-input-number
            *ngIf="head.show_valuta_id === '1'"
            [hidden]="(head.base_currency_id | uppercase) === (head.valuta_id | uppercase)"
            ttLabelView="top"
            ttLabel="exchange_rate"
            [(ttModel)]="head.exchange_rate"
            (ttModelChange)="onExchangeRateChanged()"
            ttTextAlign="right"
            ttFormatNumber
            ttDecimals="6"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-input-number>
    </div>
    <div class="w-accountingprocessing__input-group">
        <tt-input-number
            *ngIf="head.show_amount_invval_abs === '1'"
            ttLabelView="top"
            ttLabel="amount_locval_abs"
            [ttModel]="head.amount_locval_abs"
            ttTextAlign="right"
            ttFormatNumber
            ttDecimals="2"
            ttReadonly
        ></tt-input-number>
        <tt-checkbox
            *ngIf="head.show_rem_on_hold === '1'"
            class="w-accountingprocessing__input"
            ttLabelView="top"
            ttLabel="rem_on_hold"
            [(ttModel)]="head.rem_on_hold"
            (ttModelChange)="saveCustact('rem_on_hold')"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-checkbox>
        <tt-checkbox
            *ngIf="head.show_rem_never_pay === '1'"
            class="w-accountingprocessing__input"
            ttLabelView="top"
            ttLabel="rem_never_pay"
            [(ttModel)]="head.rem_never_pay"
            (ttModelChange)="saveCustact('rem_never_pay')"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-checkbox>
    </div>
    <div *ngIf="head.show_bankaccount === '1'" class="w-accountingprocessing__input-group">
        <tt-input
            *ngIf="head.show_bankaccount === '1'"
            ttLabelView="top"
            ttLabel="bankaccount"
            [(ttModel)]="head.bankaccount"
            (ttModelChange)="saveCustact('bankaccount')"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-input>
        <tt-input ttLabelView="top" ttLabel="iban" [(ttModel)]="head.iban" (ttModelChange)="saveCustact('iban')" [ttReadonly]="head.acvoucherbunt_keyno !== '0'"></tt-input>
        <tt-input ttLabelView="top" ttLabel="bic" [(ttModel)]="head.bic" (ttModelChange)="saveCustact('bic')" [ttReadonly]="head.acvoucherbunt_keyno !== '0'"></tt-input>
    </div>
    <tt-input *ngIf="head.show_kid === '1'" ttLabelView="top" ttLabel="kid" [(ttModel)]="head.kid" (ttModelChange)="saveCustact('kid')" [ttReadonly]="head.acvoucherbunt_keyno !== '0'"></tt-input>
    <tt-textarea ttLabelView="top" ttLabel="voucher_note" [(ttModel)]="head.note" (ttModelChange)="saveCustact('note')" [ttReadonly]="head.acvoucherbunt_keyno !== '0'"></tt-textarea>
    <div class="w-accountingprocessing__input-group w-accountingprocessing__input-group--wider">
        <tt-search
            *ngIf="head.show_project_name === '1'"
            ttLabelView="top"
            ttLabel="project_name"
            [(ttModel)]="head.project_name"
            [ttSearch]="searchProjects"
            (ttOnSelected)="onProjectSelected($event)"
            (ttOnClear)="onProjectSelected()"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-search>
        <tt-select
            *ngIf="head.show_department_id === '1'"
            ttLabelView="top"
            ttLabel="department"
            [(ttModel)]="head.department_id"
            (ttModelChange)="saveCustact('department_id')"
            [ttData]="departments"
            ttDataId="department_id"
            ttDataName="department_name"
            ttShowClearButton
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-select>
    </div>
    <div class="w-accountingprocessing__input-group w-accountingprocessing__input-group--wider">
        <tt-search
            *ngIf="head.show_equipment_name === '1'"
            ttLabelView="top"
            ttLabel="equipment_name"
            [(ttModel)]="head.equipment_name"
            [ttSearch]="searchEquipments"
            (ttOnSelected)="onEquipmentSelected($event)"
            (ttOnClear)="onEquipmentSelected()"
            [ttButtons]="equipmentButtons"
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-search>
        <tt-select
            *ngIf="head.show_labour_no === '1'"
            ttLabelView="top"
            ttLabel="labour"
            [(ttModel)]="head.labour_no"
            (ttModelChange)="saveCustact('labour_no')"
            [ttData]="labourers"
            ttDataId="labour_no"
            ttDataName="labour_name"
            ttShowClearButton
            [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
        ></tt-select>
    </div>
    <tt-select
        *ngIf="head.show_businessco_no === '1'"
        ttLabelView="top"
        ttLabel="businessco"
        [(ttModel)]="head.businessco_no"
        (ttModelChange)="saveCustact('businessco_no')"
        [ttData]="businessCos"
        ttDataId="businessco_no"
        ttDataName="company_name"
        [ttReadonly]="head.acvoucherbunt_keyno !== '0'"
    ></tt-select>
</ng-container>
<!-- 
<label ng-if="vm.model.custact.validationmessage > ''" class="checklist-h2e col-xs-12" tt-header="{{vm.model.custact.validationmessage}}"></label>

<tt-select tt-label-view="top" tt-label="acvouchertype" tt-model="vm.model.custact.acvouchertype_id" tt-change="vm.onVoucherTypeChanged($value)" tt-data="vm.model.voucherTypes" tt-data-id="acvouchertype_id" tt-data-name="acvouchertype_name" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-select>
<div class="col-xs-12 sp-0 w-accountingprocessing__input-group">
    
    <tt-input ng-if="vm.model.custact.show_supplier_name === '1'" class="w-accountingprocessing__input" tt-label-view="top" tt-label="acc_supp_no" tt-model="vm.model.custact.acc_supp_no" tt-readonly="true"></tt-input>
    <div ng-if="vm.model.custact.show_supplier_name === '1'" style="display: contents">
        <tt-search ng-if="vm.model.custact.cust_no === '0' || vm.model.custact.cust_no === ''" class="w-accountingprocessing__input" tt-label-view="top" tt-label="supplier_name" tt-model="vm.model.custact.supplier_name" tt-change="vm.model.custact.supplier_name = $value" tt-search="vm.searchSupplier()" tt-on-selected="vm.onSupplierSelected($item)" tt-on-clear="vm.onSupplierSelected()" tt-buttons="vm.model.supplierEmptyButtons" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}" style="flex: 4;"></tt-search>
        <tt-search ng-if="vm.model.custact.cust_no > 0" class="w-accountingprocessing__input" tt-label-view="top" tt-label="supplier_name" tt-model="vm.model.custact.supplier_name" tt-change="vm.model.custact.supplier_name = $value" tt-search="vm.searchSupplier()" tt-on-selected="vm.onSupplierSelected($item)" tt-on-clear="vm.onSupplierSelected()" tt-buttons="vm.model.supplierButtons" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}" style="flex: 4;"></tt-search>
    </div>
</div>
<div ng-if="vm.model.custact.show_cust_name === '1'"
    <tt-input class="col-xs-12 sp-0" tt-label-view="top" tt-label="acc_cust_no" tt-model="vm.model.custact.acc_cust_no" tt-change="vm.changeAndSaveCustact($value, 'acc_cust_no')" tt-readonly="true"></tt-input>
    <tt-search tt-label-view="top" tt-label="cust_name" tt-model="vm.model.custact.cust_name" tt-change="vm.model.custact.cust_name = $value" tt-search="vm.searchCustomer()" tt-on-selected="vm.onCustomerSelected($item)" tt-on-clear="vm.onCustomerSelected()" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-search>
</div>

<tt-input ng-if="vm.model.custact.show_rem_invoice_no === '1'" class="col-xs-12 sp-0" tt-label-view="top" tt-label="rem_invoice_no" tt-model="vm.model.custact.rem_invoice_no" tt-change="vm.changeAndSaveCustact($value, 'rem_invoice_no')" tt-max-length="50" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-input>
<div class="col-xs-12 sp-0 w-accountingprocessing__input-group">
    <tt-datetime ng-if="vm.model.custact.show_voucherdate === '1'" class="w-accountingprocessing__input" tt-label-view="top" tt-label="voucherdate" tt-model="vm.model.custact.voucherdate" tt-change="vm.onVoucherDateChanged($value)" tt-date-options="vm.dateOptions.voucherdate" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-datetime>
    <tt-datetime ng-if="vm.model.custact.show_transdate === '1'" class="w-accountingprocessing__input" tt-label-view="top" tt-label="transdate" tt-model="vm.model.custact.transdate" tt-change="vm.onTransDateChanged($value)" tt-date-options="vm.dateOptions.transdate" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-datetime>
    <tt-datetime ng-if="vm.model.custact.show_duedate === '1'" class="w-accountingprocessing__input" tt-label-view="top" tt-label="duedate" tt-model="vm.model.custact.duedate" tt-change="vm.onDueDateChanged($value)" tt-date-options="vm.dateOptions.duedate" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-datetime>
</div>
<div class="col-xs-12 sp-0 w-accountingprocessing__input-group">
    <tt-input-number ng-if="vm.model.custact.show_amount_invval_abs === '1'" class="w-accountingprocessing__input" tt-label-view="top" tt-label="amount_invval_abs" tt-model="vm.model.custact.amount_invval_abs" tt-change="vm.onAmountInvvalAbsChanged($value)" tt-text-align="right" tt-options="vm.numberOptions.amount" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-input-number>
    <tt-select ng-if="vm.model.custact.show_valuta_id === '1'" class="w-accountingprocessing__input" tt-label-view="top" tt-label="valuta" tt-model="vm.model.custact.valuta_id" tt-change="vm.onValutaChanged($value)" tt-data="vm.model.valutas" tt-data-id="valuta_id" tt-data-name="valuta_name" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-select>
    <tt-input-number ng-show="vm.model.custact.show_valuta_id === '1' && vm.model.custact.base_currency_id !== vm.model.custact.valuta_id" class="w-accountingprocessing__input" tt-label-view="top" tt-label="exchange_rate" tt-model="vm.model.custact.exchange_rate" tt-change="vm.onExchangeRateChanged($value)" tt-text-align="right" tt-options="vm.numberOptions.exchangeFactor" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-input-number>
</div>
<div class="col-xs-12 sp-0 w-accountingprocessing__input-group">
    <tt-input-number class="w-accountingprocessing__input" tt-label-view="top" tt-label="amount_locval_abs" tt-model="vm.model.custact.amount_locval_abs" tt-change="vm.model.custact.amount_locval_abs = $value" tt-text-align="right" tt-options="{ decimals: 2 }" tt-readonly="true"></tt-input-number>
    <tt-input ng-if="vm.model.custact.show_bankaccount === '1'" class="w-accountingprocessing__input" tt-label-view="top" tt-label="bankaccount" tt-model="vm.model.custact.bankaccount" tt-change="vm.changeAndSaveCustact($value, 'bankaccount')" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-input>
</div>
<div ng-if="vm.model.custact.show_bankaccount === '1'">
    <div class="col-xs-12 sp-0 w-accountingprocessing__input-group">
        <tt-input class="w-accountingprocessing__input" tt-label-view="top" tt-label="iban" tt-model="vm.model.custact.iban" tt-change="vm.changeAndSaveCustact($value, 'iban')" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-input>
        <tt-input class="w-accountingprocessing__input" tt-label-view="top" tt-label="bic" tt-model="vm.model.custact.bic" tt-change="vm.changeAndSaveCustact($value, 'bic')" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-input>
    </div>
</div>
<tt-input ng-if="vm.model.custact.show_kid === '1'" class="col-xs-12 sp-0" tt-label-view="top" tt-label="kid" tt-model="vm.model.custact.kid" tt-change="vm.changeAndSaveCustact($value, 'kid')" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-input>
<tt-textarea tt-label-view="top" tt-label="voucher_note" tt-model="vm.model.custact.note" tt-change="vm.changeAndSaveCustact($value, 'note')" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-textarea>
<div class="col-xs-12 sp-0 w-accountingprocessing__input-group">
    <tt-search ng-if="vm.model.custact.show_project_name === '1'" class="w-accountingprocessing__input---buttons" tt-label-view="top" tt-label="project_name" tt-model="vm.model.custact.project_name" tt-change="vm.model.custact.project_name = $value" tt-search="vm.searchProject()" tt-on-selected="vm.onProjectSelected($item)" tt-on-clear="vm.onProjectSelected()" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-search>
    <tt-select-buttons ng-if="vm.model.custact.show_department_id === '1'" class="w-accountingprocessing__input---buttons" tt-label-view="top" tt-label="department" tt-model="vm.model.custact.department_id" tt-change="vm.onDepartmentChanged($value)" tt-data="vm.model.departments" tt-data-id="department_id" tt-data-name="department_name" tt-buttons="vm.model.departmentButtons" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-select-buttons>
</div>
<div class="col-xs-12 sp-0 w-accountingprocessing__input-group">
    <tt-search ng-if="vm.model.custact.show_equipment_name === '1'" class="w-accountingprocessing__input---buttons" tt-label-view="top" tt-label="equipment_name" tt-model="vm.model.custact.equipment_name" tt-change="vm.model.custact.equipment_name = $value" tt-search="vm.searchEquipment()" tt-on-selected="vm.onEquipmentSelected($item)" tt-on-clear="vm.onEquipmentSelected()" tt-buttons="vm.model.equipmentButtons" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-search>
    <tt-select-buttons ng-if="vm.model.custact.show_labour_no === '1'" class="w-accountingprocessing__input---buttons" tt-label-view="top" tt-label="labour" tt-model="vm.model.custact.labour_no" tt-change="vm.onLabourChanged($value)" tt-data="vm.model.labours" tt-data-id="labour_no" tt-data-name="labour_name" tt-buttons="vm.model.labourButtons" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-select-buttons>
</div>
<tt-select ng-if="vm.model.custact.show_businessco_no === '1'" class="col-xs-12 sp-0" tt-label-view="top" tt-label="businessco" tt-model="vm.model.custact.businessco_no" tt-change="vm.onCustactBusinessCoChanged($value)" tt-data="vm.model.businessCompanies" tt-data-id="businessco_no" tt-data-name="company_name" tt-readonly="{{vm.model.custact.acvoucherbunt_keyno !== '0' ? 'true' : 'false'}}"></tt-select>

<tt-button-save class="col-xs-12 sp-0 hidden" tt-text="accountingprocessing_custactac_save" tt-locked="vm.locks.save" tt-button-type="submit" tt-click="vm.saveCustactAccount()" tt-text-align="center"></tt-button-save>
<tt-button ng-if="vm.model.get.show_accountingfunction === '1' && vm.model.custactNo > 0 && vm.model.custact.acvoucherbunt_keyno === '0' && vm.model.tabletQuery.matches === true" class="col-xs-12 sp-0" tt-text="accountingprocessing_delete" tt-locked="vm.locks.delete" tt-click="vm.deleteCustact()" tt-icon="fas fa-trash-alt" tt-type="danger" tt-text-align="center"></tt-button> -->
